module.exports = __webpack_public_path__ + "20250721160708/img/link.9eacf71c.png";